import { useQuery } from "@tanstack/react-query";
import { fetchProductDetails } from "@/api/collections";

export function useProductDetails(productId: string) {
  return useQuery({
    queryKey: ["product-details", productId],
    queryFn: () => fetchProductDetails(productId),
    enabled: !!productId,
  });
}
